import $http from '@/resource';
import utils from '@/utils';
import {Message, Notice} from 'view-design';

const $api = {};


/**
 * 加入已有单位
 *
 * @param {object} data 所需要用到的数据
 *
 * @returns {Promise<any>}
 */
$api.attendCompany = function(data) {
	const url = 'attend-company';
	const promise = new Promise(function(resolve){
		$http.put(url, data).then(function (response) {
		  	if (response.code == 200) {
		  	  	resolve();
		  	} else {
		  		utils.notice(response.msg, 'error');
		  	}
		});
	});
  	return promise;
}

/**
 * 用户单位的几种状态
 *
 * @returns {Promise<any>}
 */
$api.companyStep = function() {
	const url = 'company-step';
	const promise = new Promise(function(resolve){
		$http.get(url).then(function (response) {
		  	if (response.code == 200) {
		  		// response.data = {
		  		// 	step: '2',
			   //      companyName:'单位名称',
			   //      company_id:'5454',
			   //      type: '1'
		  		// };
		  	  	resolve(response.data);
		  	} else {
		  		utils.notice(response.msg, 'error');
		  	}
		});
	});
  	return promise;
}


export default $api; 


// WEBPACK FOOTER //
// ./src/service/index/joinCompany.js